import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { CostCentre } from 'assets-model';


@Component({
  selector: 'app-cost-centre-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class CostCentreEditorComponent extends CrudEditComponent<CostCentre, string> implements OnInit {

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    //this.actions = [];
  }


}






